import { motion } from "framer-motion";
import { CircleCheck } from "lucide-react";
import { MaskLine, EASE } from "@/components/Reveal";

const EXITS = [
  { date: "Mai 2026", from: "fruits GmbH", to: "OpusDNS GmbH", text: "KI-gestützte Technologie- und Datenplattform für Domainhandel; erfolgreicher Exit im Mai 2026." },
  { date: "März 2022", from: "Lentil / VIA AG", to: "culture4life (luca app)", text: "Digitales Zugangssystem; erfolgreicher Exit an luca." },
  { date: "Juli 2022", from: "Orbit Ventures GmbH", to: "Etribes Connect GmbH", text: "Venture Studio für digitale Geschäftsmodelle; erfolgreicher Exit an Etribes." },
];

export const Exits = () => (
  <section id="exits" className="grain relative overflow-hidden py-24 md:py-36 bg-primary text-primary-foreground" data-testid="exits-section">
    <div className="relative mx-auto max-w-3xl px-6 md:px-8">
      <span className="inline-flex items-center gap-3 text-xs font-medium tracking-[0.2em] uppercase text-primary-foreground/70 mb-8">
        <span className="h-px w-8 bg-current opacity-50" />Exits
      </span>
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight mb-14">
        <MaskLine>Exits - Projekte mit</MaskLine>
        <MaskLine delay={0.12}><span className="italic">meiner Beteiligung</span></MaskLine>
      </h2>
      <div className="space-y-6">
        {EXITS.map((e, i) => (
          <motion.div key={e.from} data-testid={`exit-item-${i}`}
            initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: i * 0.15 }}
            className="group flex items-start gap-5 md:gap-6 p-6 md:p-8 rounded-lg bg-primary-foreground/5 border border-primary-foreground/10 hover:bg-primary-foreground/10 transition-colors duration-300">
            <CircleCheck className="mt-1 h-6 w-6 flex-shrink-0 text-accent transition-transform duration-500 group-hover:scale-110" />
            <div>
              <div className="text-xs tracking-widest uppercase text-primary-foreground/60 mb-2">{e.date}</div>
              <div className="font-display text-xl md:text-2xl font-medium mb-2">
                {e.from}<span className="text-primary-foreground/50 mx-3">→</span><span className="text-accent">{e.to}</span>
              </div>
              <p className="text-primary-foreground/75 text-sm">{e.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
